/* eslint-disable no-unused-vars */
import React, {useState, useEffect, Fragment} from 'react'
import {Elements, StripeProvider} from 'react-stripe-elements'
import Header from '../components/HeaderIndex'
import PaymentForm from '../components/PaymentForm'
import PaymentFormExperiment from '../components/PaymentFormExperiment'
import Footer from '../components/Footer'
import {fieldErrors} from '../utils/errors'
import CheckIcon from '../assets/check-icon.svg'
import CurlyArrowDown from '../assets/curly-arrow-down.svg'

import Img from 'gatsby-image'
import Button from '../components/Button'
import Spinner from '../components/Spinner'
import Fab from '@material-ui/core/Fab'
import {checkPhoneNumber, checkNumeric, checkEmail, checkEmailPremium, checkPhonePremium, validateEmailDomain, emailDomainFormat} from '../utils/Helper'
import GreenArrow from '../assets/arrow-green.svg'
import GreenWhiteArrow from '../assets/arrow-green-white.svg'

import Lock from '../assets/lock.svg'
import { graphql, navigate, Link } from 'gatsby'
import Media from 'react-media'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { logPage, logEvent, pushToDataLayer } from '../components/Analytics'
import { Experiment, Variant } from "react-optimize";
import { Helmet } from 'react-helmet';

const loadScript = src =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.addEventListener('load', () => {
      resolve({ successful: true })
    })
    script.addEventListener('error', event => {
      reject({ error: event })
    })
    document.head.appendChild(script)
  })


const StartBackground = ({device}) => {
	return (
		<div style={{position: 'relative'}}>
		<Media query="(max-width: 767px)">
			{
				matches =>
					matches ? (
						<Fragment>
							
						</Fragment>
					) : (
						<Fragment>
						<div className="back-img">
							{/* <StartPageBackgroudCircle id="startPageBackgroundCircle" />
							<StartPageBackgroudCircle2 id="startPageBackgroundCircle2" />
							<StartPageBackground id="startPageBackground" />
							<StartPageBackgroundUnder id="startPageBackgroundUnder" />
							<StartPageBackgroundSymbols id="startPageBackgroundSymbols" /> */}
							</div>
						</Fragment>
					)
			}
		</Media>
		</div>
	)
}

const AccountForm = ({data, device, inviteBy}) => {
	const [accountType, setAccountType] = useState('junior')
	const [email, setEmail] = useState('')
	const [emailDomain, setEmailDomain] = useState('')
	const [terms, setTerms] = useState(false)
	const [errorText, setErrorText] = useState('')
	const [stripForm, setStripForm] = useState(false)
	const [phoneNumber, setPhoneNumber] = useState('')
	const [nameOnCard, setNameOnCard] = useState('')
	const [disabled, setDisabled] = useState(false)
	const [loading, setLoading] = useState(false)
	const [campaign, setCampaign] = useState('common')
	const [referby, setReferby] = useState('')
	
	// error
	const [errorEmail, setErrorEmail] = useState('')
	const [errorPhone, setErrorPhone] = useState('')
	const [errorCheckbox, setErrorCheckbox] = useState('')
	const [errorNameCard, setErrorNameCard] = useState('')

	const [stripeLoaded, setStripeLoaded] = useState({})
	useEffect(() => {
		const fetchData = async () => {
			const result = await loadScript('https://js.stripe.com/v3/')
		setStripeLoaded(result)
		}
		fetchData();
		if (typeof inviteBy !== 'undefined') {
			setReferby(inviteBy);
		}
	}, []) 	

	const AccountTypeButton = ({title, sub, active, onClick}) => {
		let buttonStyle = {
			borderRadius: '5px',
			border: 'solid 2px #e4e4eb',
			backgroundColor: '#fff'
		}

		let activeButtonStyle = {
			borderRadius: '5px',
			borderStyle: 'solid',
			borderWidth: '2px',
			background: 'linear-gradient(79deg, #53a0fe, #43c0dc 6%, #33e2b9 63%, #43c0dc 90%, #53a0fe)',
			color:'#32e2b9'
		}

		return (
			<div className='accountTypeButton' onClick={onClick} style={active ? activeButtonStyle : buttonStyle}>
				<div className="inner-area">
					<h2>{title}</h2>
					<p>{sub}</p>
				</div>
				{active ? <CheckIcon alt='Check Icon' className='account-type-icon' /> : null}
			</div>
		)
	}

	const handleInput = e => {
		setEmail(e.target.value.trim())
		setEmailDomain('');
		if(validateEmailDomain(e.target.value)){
			setEmailDomain(fieldErrors.emailDomain)
		}
	}

	const domainCorrection = () => {
		var correctEmail = emailDomainFormat(email);
		setEmail(correctEmail)
	}

	const handlePhoneInput = e => {
		setPhoneNumber(e.target.value)
	}
	const handleNameOnCard = e => {
		setNameOnCard(e.target.value)
	}
	
	function checkSubmit (e) {
		// empty error
		setErrorText('')
		setErrorEmail('')
		setErrorPhone('')
		setErrorCheckbox('')

		if (!email.length) return setErrorEmail(fieldErrors.emailEmpty)
		if (!checkEmail(email)) return setErrorEmail(fieldErrors.invalidEmail)
		
		if(accountType === 'senior'){
			if(phoneNumber === '') return setErrorPhone(fieldErrors.phoneNumberEmpty)
			if(!checkNumeric(phoneNumber)) return setErrorPhone(fieldErrors.phoneNumber)
			if(!checkPhoneNumber(phoneNumber)) return setErrorPhone(fieldErrors.phoneNumberFormat)
		}
		if (!terms) return setErrorCheckbox(fieldErrors.terms)
		
		setLoading(true);
		setDisabled(true);

		checkEmailPremium(email, (resp) => {
			setLoading(false);
			setDisabled(false);
			if(!resp){
				if(accountType === 'senior'){
					setLoading(true);
					setDisabled(true);
					checkPhonePremium(phoneNumber, (phoneResp) => {
						setLoading(false);
						setDisabled(false);
						if(!phoneResp){
							setStripForm(true)				
						}else{
							setErrorPhone(fieldErrors.userAlreadyPremiumWithPhone)
						}
					})
				}else{
					setStripForm(true)				
				}
			}else{
				setErrorEmail(fieldErrors.userAlreadyPremium)
			}			
		})
	}
	return stripeLoaded.successful ? (
		<div className='accountFormContainerMobile' id="accountForm">
			<StripeProvider apiKey={process.env.STRIPE_PK}>
				<form>
					<div className="steps-inner-line">
						<ul>
							<li className={stripForm === false ? 'active' : 'done'}>
								<span></span>
							</li>
							<li className={stripForm === true ? 'active' : ''}>
								<span></span>
							</li>								
						</ul>							
					</div>

					<div style={{display: stripForm === true ? 'none': 'block'}} >
						<div className='accountFormContent'>
							<h2>Registrera dig</h2>
							<p className="desktop">Just nu gör vi bedömningen att många svenska föräldrar och barn är <br/> hemma p.g.a. Covid-19 och därför i extra stort behov av digitala <br/> hjälpmedel. <b>Albert stöttar därför med denna tjänst gratis tillsvidare.</b></p>
							<p className="for-mobile">Just nu gör vi bedömningen att många <br/> svenska föräldrar och barn är  hemma p.g.a. <br/> Covid-19 och därför i extra stort behov av <br/> digitala hjälpmedel. <b>Albert stöttar därför med <br/> denna tjänst gratis tillsvidare.</b></p>

							<p className="desktop">Ange ålder och e-postadress för att skapa konto. Instruktioner, kod och <br/> uppdateringar skickas som e-post.</p>
							<p className="for-mobile">Ange ålder och e-postadress för att skapa <br/> konto. Instruktioner, kod och uppdateringar <br/> skickas som e-post.</p>
						</div>
						<div className='accountTypes'>
							<AccountTypeButton 
								title='ÅLDER 3-9 ÅR'
								sub='(Förskola—Åk3)'
								active={accountType === 'junior' ? true : false}
								onClick={() => setAccountType('junior')}
							/>
							<AccountTypeButton
								title='ÅLDER 10-16 ÅR'
								sub='(Åk4—Åk9)'
								active={accountType === 'senior' ? true : false}
								onClick={() => setAccountType('senior')}
							/>
						</div>
						<div className='accountFormEmail'>
							<h4>E-post</h4>
							<input type='text' id='email' placeholder="Ange E-postadress" value={email} onBlur={domainCorrection} onChange={handleInput} className={errorEmail!== '' ? 'errorField' : ''}/>
							<label className="text-error">{errorEmail}</label>
							<label className="text-error">{emailDomain}</label>
							
						</div>

						{
							accountType === 'senior' && (
								<div className='accountFormEmail'>
									<h4>Ditt barns Telefonnummer</h4>
									<input type='text' id='phone' placeholder="Ange mobilnummer" value={phoneNumber}  className={errorPhone!== '' ? 'errorField' : ''} onChange={handlePhoneInput} pattern="\d*"/>
									<label className="text-error">{errorPhone}</label>
								</div>
							)
						}

						<div className='accountFormRegisterButtonMobile'>
							<input type='checkbox' id='terms_and_conditions' onChange={() => setTerms(!terms)} />
							<label htmlFor='terms_and_conditions'>Jag godkänner Alberts <a href="/terms-and-conditions" target="_blank" className='color-text'> Allmänna Villkor </a></label>
						</div>
							<label className="text-error">{errorCheckbox}</label>
							
							<Fab
								variant="extended"
								color="primary"
								aria-label="Add"
								className="registerButton"
								disabled={disabled}
								onClick={(e) => {
										logEvent(
											`Start page register button`,
											`Start page register button was clicked`
										);
										pushToDataLayer(
											'userClick',
											'Start Page Register Button',
											'Start Page Register Button Was Clicked'
										)
										checkSubmit(e)
									}
								}
								>
								Skapa Konto
							</Fab>
							{
								loading && (
									<div className="loader-cenetr"> <Spinner size={48}/></div>
								)
							}
					</div>

					<div style={{display: stripForm === false ? 'none': 'block'}}>
						<div className='accountFormContent'>
							<h2>Obegränsad läxhjälp!</h2>
							<p className="desktop">Just nu gör vi bedömningen att många svenska föräldrar och barn är hemma <br/> <b>p.g.a. Covid-19 och därför i extra stort behov av digitala hjälpmedel. Albert <br/> stöttar därför med denna tjänst gratis tillsvidare.</b> Ordinarie pris 99kr/månad.</p>
							<p className="for-mobile">Just nu gör vi bedömningen att många <br/> svenska föräldrar och barn är hemma <b>p.g.a.<br/> Covid-19 och därför i extra stort behov av <br/> digitala hjälpmedel. Albert stöttar därför med <br/> denna tjänst gratis tillsvidare.</b> Ordinarie pris <br/> 99kr/månad.</p>
							<p className="desktop">Albert kommer i god tid, med minst en veckas varsel, informera om <br/> eventuella prisjusteringar per e-post</p>
							<p className="for-mobile">Albert kommer i god tid, med minst en veckas <br/> varsel, informera om eventuella prisjusteringar <br/> per e-post</p>
							{/* <p>Gratis läxhjälp året ut. Därefter 99kr/mån för obegränsad tillgång till Albert 24/7 alla dagar om året.</p> */}
							{/* <p>Testa gratis i 30 dagar. Därefter fortsatt obegränsad tillgång till roligt och lärorikt material, när och varsomhelst för 99kr/mån.</p> */}
						</div>
						<div className='accountFormEmail'>
							<h4>Namn på kortet</h4>
							<input type='text' value={nameOnCard} className={errorNameCard!== '' ? 'errorField' : ''} onChange={handleNameOnCard}  placeholder="Albert Albertina"/>
							<label className="text-error">{errorNameCard}</label>
						</div>
						<Elements>
									<PaymentForm email={email} terms={terms} accountType={accountType} phone={phoneNumber} errorMsg={setErrorText} setCardNameError={setErrorNameCard} cardName={nameOnCard} errorText={errorText} referby={referby}/>
								</Elements>
						{/* <Experiment id={process.env.GOOGLE_OPTIMIZE_EXPERIMENT_ID}>
								<Variant default id="0">
									<Elements>
									<PaymentForm email={email} terms={terms} accountType={accountType} phone={phoneNumber} errorMsg={setErrorText} setCardNameError={setErrorNameCard} cardName={nameOnCard} errorText={errorText} referby={referby}/>
								</Elements>
							</Variant> 
								<Variant id="1">
									<Elements>
									<PaymentFormExperiment email={email} terms={terms} accountType={accountType} phone={phoneNumber} errorMsg={setErrorText} setCardNameError={setErrorNameCard} cardName={nameOnCard} errorText={errorText} setCamp={setCampaign} campaign={campaign}  referby={referby}/>
								</Elements>
							</Variant>
						</Experiment> */}
						
						<p className="paymentInfoOne"><Lock /> &nbsp; Säker kortbetalning via en krypterad anslutning.</p>
						<p className="paymentInfoTwo">Bra att veta: Ordinarie pris är 99kr/månad, men just nu gratis tillsvidare. Du kan närsomhelst, utan uppsägningstid avsluta din prenumeration genom att logga in på Mina Sidor. Albert informerar om eventuella framtida prisjusteringar per e-post.</p>
					</div>
				</form>
			</StripeProvider>
		</div>
	) : null
	
	
}

const Sponsors = ({data, device}) => {

	const [slideActive, setSlideActive] = useState(0)
	const sponsorStyle = {
		width: 'auto',
		height: '50px'
	}

	const list = [
		<img src={data.goteborgsvarvet.publicURL} style={sponsorStyle} />,		
		<img src={data.generation_pep.publicURL} style={sponsorStyle} />,
		<img src={data.jollyroom_logo.publicURL} style={sponsorStyle} />,		
		<img src={data.stockholm_marathon.publicURL} style={sponsorStyle} />,		
		<img src={data.tjejmilen.publicURL} style={sponsorStyle} />,		
		<img src={data.ica_logo.publicURL} style={sponsorStyle} />,		
		]

	var settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	  };
		return (
			<div className='logo-sec1'>
				<div className='logo-sec-inner'>
					<h2 style={{ margin: '0 0 5rem 0'}}>Stolta samarbetspartners</h2>
					<div className="for-mobile">
						<Slider {...settings}>
							{
								list.map((sponsor, idx) => {
									return <div key={idx} >{sponsor}</div>
								})
							}
						</Slider>
					</div>
					<div className="desktop">
						<div style={{width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>
							{list.map((sponsor, idx) => {
								return <div key={idx} style={{alignItems: 'center', display: 'flex', maxHeight: '5rem'}}>{sponsor}</div>
							})}
						</div>
					</div>
				</div>
			</div>
		)
	
}

const TrialAccountSection = ({data, inviteBy}) => {
	return (
		<div className='form-sec start-page-form' style={{display: 'flex', alignItems: 'center', padding: '3rem 0', flexDirection: 'column'}}>
			<CurlyArrowDown />
			<div className="desktop"style={{margin: '3rem 0', textAlign: 'center'}}>
				<h1>Ditt barns digitala mattelärare.</h1>
				<h1 style={{color: '#32e2b9'}}>Prova Albert gratis!</h1>
			</div>
			<div className="for-mobile" style={{margin: '3rem 0', textAlign: 'center'}}>
				<h1>Ditt barns digitala mattelärare.</h1>
				<h1 style={{color: '#32e2b9'}}>Testa Albert gratis!</h1>
			</div>
			<AccountForm data={data} inviteBy={inviteBy}/>
		</div>
	)
}

const Review = ({title, text, data}) => {
	const { BlueRectangleBottom } = data
	const reviewStyle = {
		width: '100%',
		maxWidth: '40rem',
		background: '#fff',
		borderRadius: '0.5rem',
		padding: '2rem 2rem 5rem',
		backgroundImage: `url(${BlueRectangleBottom.publicURL})`,
		backgroundSize: 'contain',
		backgroundPosition: 'bottom',
		backgroundRepeat: 'no-repeat',
		margin:'auto'
	}
	return (
		<div style={reviewStyle}>
			<h2>{title}</h2>
			<p style={{margin: '0 0 1rem 0'}}>{text}</p>
		</div>
	)
}

const StartReview = ({ data }) => {
	const {gradientBackground} = data
	const [active, setActive] = useState(0)
	const [components, setComponents] = useState([])

	const reviews = [
		{
			title: 'Äntligen förstår jag! - Rose åk 9',
			text: 'Albert är en fantastisk app som hjälper både mig och de som behöver extra mycket hjälp i matte. När jag löste uppgifter i Albert så märkte jag inte att det var lika svårt eftersom hans förklaringar får mig att fatta! Hade jag löst uppgifterna utan stöd från Albert hade det tagit väldigt lång tid för mig att förstå.'
		},
		{
			title: 'Snabbare, bättre och roligare! - Johanna åk 8',
			text: 'Jag älskar Albert, jag tycker att det är superbra att det finns en app som hjälper alla på högstadiet att verkligen kunna räkna ut matteuppgifter på rätt sätt så att man förstår. Albert hjälper mig att räkna ut uppgifter som jag fastnat på fortare och bättre, med snabba tips, hela uträkningar och roliga videos att titta på.'
		},
		{
			title: 'Alberts lektioner! - Teo åk 7',
			text: 'Albert är grym! Jag tycker mest om lektionerna som enkelt förklarar olika kapitel. Jag förstod inte vad algebra var riktigt, men genom Alberts lektion som bara var typ 2 minuter så fattade jag direkt! Han är bäst!'
		},
	]

	useEffect(() => {
		if (reviews.length !== components.length) {
			let list = [...components]
			reviews.map((review, idx) => {
				list.push(<Review data={data} title={review.title} text={review.text} key={idx} />)
			})
			setComponents(list)
		}
	}, [])

	var settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	};

	return (
		<div className='testimonial-sec'  style={{
			backgroundImage: `url(${gradientBackground.publicURL})`, 
		}}>
			
			<h3>Våra användare berättar om Albert</h3>
			<div className='test-inner'>
				<div style={{justifyContent: 'center', position: 'relative'}}>
					
					<Slider {...settings}>
						{
							components.map((sponsor, idx) => {
								return <div key={idx} >{sponsor}</div>
							})
						}
					</Slider>
				</div>
			</div>
		</div>
	)
}

const StartContent = ({data, device}) => {
	const [toggle, setToggle] = useState(true)
	const startContent = {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		zIndex: 2
	}

	const USP = ({icon, title, text, badgeColor, style={}}) => {
		const uspListItem = {
			margin: '0 0.5rem',
			flex: 1,
			position: 'relative'
		}
		const uspStyle = {
			background: '#f6f6f9', 
			display: 'flex', 
			flexDirection: 'column', 
			alignItems: 'center',
			padding: '1rem 2rem',
			minHeight: '15rem',
			borderRadius:'10px'
		}
		const iconBadge = {
			background: badgeColor,
			width: '5rem',
			height: '5rem',
			borderRadius: '50%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			margin: '-3.5rem 0 1rem 0'
		}

		return (

			<li>
				<figure>
				{icon}
				</figure>
				<figcaption>
					<h4>{title}</h4>
					<p>{text}</p>
				</figcaption>
			</li>
		)
	}

	const USPListJunior = ({data , style}) => {
		return (
			<div className={`albert-three start-page ${style}`} >
				<ul className='' >
					<USP
						icon={<img src={data.juniorBank.publicURL} />}
						badgeColor='linear-gradient(229deg, #7798ff, #767bff)'
						title='Innehåll baserat på forskning'
						text='Grundlig forskning säkerställer att ditt barn lär sig i enlighet med läroplanen och skapar förutsättningar inför mer komplicerade matteuppgifter längre fram.'
					/>
					<USP
						icon={<img src={data.juniorHouseGreen.publicURL} />}
						badgeColor='linear-gradient(229deg, #32e2b9, #46d4c8)'
						title='Oändligt antal interaktiva övningar'
						text='Alberts interaktiva sätt att lösa uppgifter gör det roligt för barn att förstå och lära sig matematik. Att engagera på ett underhållande sätt är grunden för en god lärupplevelse för yngre barn.'
					/>
					<USP
						icon={<img src={data.juniorHouseOrrange.publicURL} />}
						badgeColor='linear-gradient(227deg, #fdd15f, #fbaf62)'
						title='Spelinspirerad upplevelse'
						text='En spelinspirerad kunskapsresa där ditt barn når nya nivåer genom utmaningar och positiv feedback. Tillsammans med Albert utvecklas barn i sin egen takt på ett underhållande och inspirerande sätt.'
					/>
				</ul>
			</div>
		)		
	}

	const USPListSenior = ({data, style}) => {
		return (
			<div className={`albert-three start-page ${style}`} >
				<ul className='' >
					<USP
						icon={<img src={data.usp_house.publicURL} />}
						badgeColor='linear-gradient(229deg, #7798ff, #767bff)'
						title='Utvecklad av erfarna pedagoger och lärare'
						text='Tusentals uppgifter och interaktiva övningar, speciellt framtagna för att öka förståelsen och glädjen för matematik.'
					/>
					<USP
						icon={<img src={data.usp_play.publicURL} />}
						badgeColor='linear-gradient(229deg, #32e2b9, #46d4c8)'
						title='Hundratals animerade lektioner'
						text='Tillgång till +300 animerade lektioner som med exempel från det verkliga livet garanterat gör matten roligare.'
					/>
					<USP
						icon={<img src={data.usp_book.publicURL} />}
						badgeColor='linear-gradient(227deg, #fdd15f, #fbaf62)'
						title='Övningar baserade på gällande läroplan'
						text='Tillgång till tusentals övningar som är anpassat efter årskurs och svenska läroplanens kunskapsmål.'
					/>
				</ul>
			</div>
		)		
	}

	let imageStyle = {
		flex: 1, 
		minHeight: '-webkit-fill-available', 
		marginRight: '1rem', 
		width: 'auto', 
		objectFit: 'contain', 
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: 'contain'
	}

	return (
		<div style={startContent} className='startContent' id="sector">
			<div className='contentsection icon-sec'>
				<h1>Vem är Albert?</h1>
				<p style={{textAlign: 'center', color:'#505068'}} className="desktop">
					Albert är barnens digitala mattelärare. Med tusentals övningar och animerade videos <br/> hjälper han dig att förstå matematiken du behöver kunna för just din årskurs. Albert <br/> har utvecklats av erfarna pedagoger, lärare och forskare för att kunna lära ut matte på <br/> ett smart, roligt och pedagogiskt sätt. Perfekt för barn från förskoleålder till högstadiet.
				</p>
				<p style={{textAlign: 'center', color:'#505068'}} className="for-mobile">
					Albert är barnens digitala mattelärare. Med <br/> tusentals övningar och animerade videos <br/> hjälper han dig att förstå matematiken du <br/> behöver kunna för just din årskurs. Albert har <br/> utvecklats av erfarna pedagoger, lärare och <br/> forskare för att kunna lära ut matte på ett <br/> smart, roligt och pedagogiskt sätt. Perfekt för <br/> barn från förskoleålder till högstadiet.
				</p>
			</div>
			<div className="toogleJuniorSenior"  onClick={() => setToggle(!toggle)}>
				<div className={`toggleDiv  ${toggle === true ? 'junior' : 'senior'}`}></div>
				<div className="toggleText" style={{color: toggle ? '#fff' : '#505068'}}>
					<p>ÅLDER 3—9 ÅR</p>
				</div>
				<div className="toggleText" style={{color: !toggle ? '#fff' : '#505068'}}>
					<p>ÅLDER 10—16 ÅR</p>
				</div>
			</div>

			{
				toggle ? <USPListJunior data={data} style={toggle ? 'showJuniorSec' : ''}/>  : <USPListSenior data={data} style={!toggle ? 'showSeniorSec' : ''}/>
			}


			<div className="campaign">
				
				<ul>
					<li>
						<div >
							<figure>
								<img src={data.free_img.publicURL}/>
								<label className="tagged">Kampanj</label>
							</figure>	
							<figcaption>
								<h3>Albert stöttar alla barn i Sverige med gratis läxhjälp</h3>
								<p>Villrådiga föräldrar, stängda skolor och Covid-19 <br/> får miljontals barn världen över att stanna <br/> hemma. </p>
								<div className='anch-div'><a href="/hemundervisning/" onClick={e => pushToDataLayer(
										'userClick',
										'Start Page Det är smart Button',
										'Start Page Det är smart Was Clicked'
									)}>Läs mer <GreenArrow/></a></div>
							</figcaption>
						</div>
					</li>
					<li>
						<div >
							<figure>
								<img src={data.three_child.publicURL}/>
								<label className="tagged blue">Sponsring</label>
							</figure>	
							<figcaption>
								<h3>Det är smart att röra på sig!</h3>
								<p>I vår strävan efter att hjälpa barn med plugget   <br/> insåg vi att många studier pekar på tydliga <br/>positiva samband mellan fysisk aktivitet och inlärning.</p>
								<div className='anch-div'><a href="/sponsring/" onClick={e => pushToDataLayer(
											'userClick',
											'Start Page Det är smart Button',
											'Start Page Det är smart Was Clicked'
										)}>Läs mer <GreenArrow/></a></div>
							</figcaption>		

						</div>
					</li>
					
					<li>
						<div >
							<figure>
								<img src={data.coupon_lady.publicURL}/>
								<label className="tagged">Kampanj</label>
							</figure>
							<figcaption>
								<h3>ICA Maxi bjuder sina kunder	</h3>
								<p>Utvalda Ica Maxi butiker bjuder sina kunder på <br/>30 dagars fri provperiod. <em>(Gäller endast nya <br/>kunder)</em></p>
								<div className='anch-div'><a href="https://ica.hejalbert.se/ica" target="_blank" onClick={() => {logEvent(
											`Start page ICA Maxi button`,
											`Start page ICA Maxi was clicked`
										);pushToDataLayer(
											'userClick',
											'Start Page ICA Maxi Button',
											'Start Page ICA Maxi Was Clicked'
										)}}>Läs mer <GreenArrow/></a></div>
							</figcaption>
						</div>
					</li>

				</ul>
				
			</div>





			<div className='three-section-bottom'>

				{/* <div style={{...imageStyle, marginRight: '1rem', backgroundImage: `url(${data.AlbertHat.publicURL})`}}></div> */}
			<div className="col-md-6 col-sm-6 col-lg-6 col-xs-12"><img src={data.AlbertHat.publicURL}/></div>
			<div className="col-md-6 col-sm-6 col-lg-6 col-xs-12"> 
				<div className='right-content'>
					<div>
						<h1 className="desktop">Personlig mattelärare, <br/> tillgänglig alla dagar — <br/> dygnet runt.</h1>
						<h1 className="for-mobile">Personlig mattelärare, <br/> tillgänglig alla dagar — <br/> dygnet runt.</h1>
						<p className="desktop">Vissa tycker matte är lätt och roligt medan andra finner <br/> det svårt och tråkigt. Albert finns här för dig <br/> oavsett!</p>
						<p className="for-mobile">Vissa tycker matte är lätt och roligt medan andra <br/> finner det svårt och tråkigt. Albert finns här för <br/> dig oavsett!</p>
						
						
						<Link to='/senior' 
							onClick={() => {logEvent(
										`Start page senior button`,
										`Start page senior was clicked`
									);
									pushToDataLayer(
										'userClick',
										'Start Page Senior Button',
										'Start Page Senior Was Clicked'
									)
								}} 
							className="border-btn">Läs mer om Albert <GreenWhiteArrow/>
						</Link>
						

					</div>
				</div>
				</div>
			</div>

			<div className='three-section-bottom second-start'>
			<div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 for-mobile"><img src={data.GeometryBuddies.publicURL}/></div>
			<div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
				<div className='right-content'>
					<div>
						<h1 className="desktop">Albert Junior. Speciellt <br/> för våra yngsta kompisar.</h1>
						<h1 className="for-mobile">Albert Junior. Speciellt för våra <br/> yngsta kompisar.</h1>
						<p className="desktop">En spelinspirerad kunskapsresa för de yngsta barnen. <br/> Positiv feedback med fokus på nyfikenhet och roliga <br/> övningar.</p>
						<p className="for-mobile">En spelinspirerad kunskapsresa för de yngsta <br/> barnen. Positiv feedback med fokus på nyfikenhet och <br/> roliga övningar.</p>
						
						<Link to='/junior'
							onClick={() => {logEvent(
								`Start page junior button`,
								`Start page junior was clicked`
							);
							pushToDataLayer(
								'userClick',
								'Start Page Junior Button',
								'Start Page Junior Was Clicked'
							)}} 
							className="border-btn">Läs mer om Junior <GreenWhiteArrow/>
						</Link>
						
					</div>
				</div>
				</div>
				<div className="col-md-6 col-sm-6 col-lg-6 col-xs-12 desktop"><img src={data.GeometryBuddies.publicURL}/></div>
				{/* <div style={{...imageStyle, marginLeft: '1rem', backgroundImage: `url(${data.GeometryBuddies.publicURL})`}}></div> */}
			</div>
		</div>
	)
}


const UniqueSellingPoint = ({data, title}) => {
	return (
		<li className='ul-list-item'>
			<CheckIcon alt='Check Icon' className='list-icon' />
			<h2 className='home-banner-list'>{title}</h2>
		</li>
	)
}

const StartHero = ({data, device}) => {
	
		return (
			<div id="mainContent" >
				<div className="headerBannerSection StartYear-Banner">
					<h3 className="home-banner-subheding">Alla behöver hjälpas åt!</h3>
					<h1 className="home-banner-heading desktop">Albert erbjuder nya medlemmar <br/> gratis läxhjälp tillsvidare.</h1>

					<h1 className="home-banner-heading for-mobile">Albert erbjuder nya <br/> medlemmar gratis <br/> läxhjälp tillsvidare.</h1>

					<ul>
						{/* <li>Träna inför nationella provet</li> */}
						<li>Övningar baserade på gällande läroplan</li>
						<li>Utvecklad av erfarna pedagoger och lärare</li>
					</ul>

					<div style={{ display: 'inline-flex' }}>
						<div className="header-btn">
							<Button
								title={`PROVA GRATIS`}
								subTitle="Ordinarie pris 99 kr/mån"
								id='newAccountStartPage'
								handleClick={() => document.getElementById('accountForm').scrollIntoView({behavior: 'smooth', block: 'center'})}
								style={{ width: '12rem' }}
							/>
						</div>
						<div className="desktop" style={{flex: 1}}>
							<Button title='Läs mer'
								id='readMoreStartPage'
								handleClick={() => document.getElementById('sector').scrollIntoView({behavior: 'smooth'})}
								style={{width: '8rem', height: '3rem', borderRadius: '30px'}}
							/>
						</div>
					</div>
				</div>
				
				<div className="banner-photo-desktop desktop">
					<img src={data.desktop_banner_photo.publicURL} />
				</div>
				<div className="text-center"><img src={data.mobileBanner.publicURL} className="for-mobile baaner-img"/></div>
			</div>
		) 
	
}

export default ({data, id}) => {
	const [device, setDevice] = useState('desktop')
	
	useEffect(() => {
		logPage()

		if (typeof window !== 'undefined') {
			if (window.innerWidth > 1000) {
				setDevice('desktop')
			} else {
				setDevice('mobile')
			}
		}
	}, [device])

	return (
		<div className="mainContainer">
			{/* <Helmet>
				<meta property="og:type" content="website"/>
				<meta property="fb:app_id" content="271034299921078"/>
				<meta property="og:url" content={`https://hejalbert.se/invite/${id}`}/>
				<meta property="og:title" content="Varsågod, jag bjuder på gratis läxhjälp!"/>
				<meta property="og:description" content="Jag bjuder härmed in dig att prova på Albert - Barnens digitala mattelärare, gratis tillsvidare! Klicka på länken för att ta emot gåvan."/>
				<meta property="og:image" content={`https://hejalbert.se${data.desktop_banner_photo.publicURL}`}/>

				<meta property="title" content="Varsågod, jag bjuder på gratis läxhjälp!"/>
				<meta property="description" content="Jag bjuder härmed in dig att prova på Albert - Barnens digitala mattelärare, gratis tillsvidare! Klicka på länken för att ta emot gåvan."/>

            </Helmet> */}
			<StartBackground device={device} />
			<div className="mobileBG">
				<Header color='#fff' device={device} title="Albert" referUserId={id}/>
				<StartHero data={data} device={device} />
				{/* {typeof window !== 'undefined' ? <Snow height={device === 'desktop' ? 850 : 500} width={window.innerWidth} /> : null} */}
			</div>
			<StartContent data={data} device={device} />
			<StartReview data={data} device={device} />
			<TrialAccountSection data={data} device={device} inviteBy={id} />
			<Sponsors data={data} device={device} />
			<Footer/>
		</div>
	)
}

export const query = graphql`
query {
  iPhoneiPad: file(relativePath: {regex: "/iphone-ipad/"}) {
    childImageSharp {
			fluid {
				...GatsbyImageSharpFluid
			}
		}
	}
	newHeader: file(relativePath: {regex: "/new-header/"}) {
		publicURL
	}
	greenRobo: file(relativePath: {regex: "/albert-green-robo/"}) {
		publicURL
	}
	albertStand: file(relativePath: {regex: "/albert-stand/"}) {
		publicURL
	}
	gradientBackground: file(relativePath: {regex: "/blue-gradient-bg/"}) {
		publicURL
	}
	BlueRectangleBottom: file(relativePath: {regex: "/blue-rectangle-bottom/"}) {
		publicURL
	}
	AlbertHat: file(relativePath: {regex: "/albert-hat/"}) {
		publicURL
	}
	GeometryBuddies: file(relativePath: {regex: "/geometry-buddies/"}) {
		publicURL
	}
	juniorBank: file(relativePath: {regex: "/group-19/"}) {
		publicURL
	}
	juniorHouseGreen: file(relativePath: {regex: "/group-20/"}) {
		publicURL
	}
	juniorHouseOrrange: file(relativePath: {regex: "/group-25/"}) {
		publicURL
	}
	leftArrow: file(relativePath: {regex: "/left-arrow/"}) {
		publicURL
	}
	rightArrow: file(relativePath: {regex: "/right-arrow/"}) {
		publicURL
	}
	mobileBanner: file(relativePath: {regex: "/mobile-image-StartYear/"}) {
		publicURL
	}
	usp_house: file(relativePath: {regex: "/usp-house/"}) {
		publicURL
	}
	usp_play: file(relativePath: {regex: "/usp-play/"}) {
		publicURL
	}
	usp_book: file(relativePath: {regex: "/usp-book/"}) {
		publicURL
	}
	startpage_mobile_background: file(relativePath: {regex: "/startpage_mobile_background/"}) {
		publicURL
	}
	ica_logo: file(relativePath: {regex: "/ICA-logotyp/"}) {
		publicURL
	}
	tjejmilen: file(relativePath: {regex: "/tjejmilen/"}) {
		publicURL
	}
	goteborgsvarvet: file(relativePath: {regex: "/goteborgsvarvet/"}) {
		publicURL
	}
	stockholm_marathon: file(relativePath: {regex: "/asics-stockholm-marathon/"}) {
		publicURL
	}
	jollyroom_logo: file(relativePath: {regex: "/jollyroom_logo/"}) {
		publicURL
	}
	generation_pep: file(relativePath: {regex: "/generation-pep/"}) {
		publicURL
	}
	desktop_banner_photo: file(relativePath: {regex: "/desktop-banner-img/"}) 
	{
		publicURL
	}
	coupon_lady: file(relativePath: {regex: "/coupon-lady/"}) 
	{
		publicURL
	}
	three_child: file(relativePath: {regex: "/three-child/"}) 
	{
		publicURL
	}
	free_img: file(relativePath: {regex: "/free-img/"}) 
	{
		publicURL
	}
}
`
